import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import PlanEditor from "../revenue/PlanEditor";
import { useCustomer } from "./CustomerLayout";

/** Admin: edit a customer's billing plan, saved as its next version. */
export default function CustomerBillingPlan() {
  const { customer } = useCustomer();
  const { me } = useAuth();
  const navigate = useNavigate();
  if (!me?.user.is_admin) {
    return <div className="empty">Only an admin can change a billing plan.</div>;
  }
  return (
    <div>
      <p>
        <Link to={`/c/${customer.name}/revenue`}>← Revenue</Link>
      </p>
      <PlanEditor
        customer={{ id: customer.id, slug: customer.name, name: customer.display_name }}
        onSaved={() => navigate(`/c/${customer.name}/revenue`)}
      />
    </div>
  );
}
